// selectedorderdataReducer.js

import { SET_ORDERDATA_SELECTED, SET_PAYMENTDATA_SELECTED, SET_PAYMENTMOLLIEINSTANCE_SELECTED, SET_SHIPPINGDATA_SELECTED, SET_PICKUPDATA_SELECTED, SET_SHIPORDELIVERDATA_SELECTED, SET_DELIVERORPAYADDRESSDATA_SELECTED, SET_ADDITIONALFORMINPUT_SELECTED } from '../../actions/checkoutactions/checkoutActions';

// Anfangszustand
const initialState = {
  //selectedorderdata: null // Anfangs ist keine orderdata ausgewählt
  paymentdata: null,      // Nachname, Rechnung etc.
  paymentmollieinstance: null,      // Payment MollieInstance
  shippingdata: null,     // Einzelversand, Sammelversand etc.
  pickupdata: null,       // Pickuppoint
  additionalforminput: null,       // Additional forminput
  shipordeliverdata: 'delivery',
  deliverorpayaddressdata: 'delivery'
};

// Reduzierer
const selectedorderdataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ORDERDATA_SELECTED:
      return {
        ...state,
        selectedorderdata: action.payload // Setze die Orderdata
      };
    case SET_PAYMENTDATA_SELECTED:
      return {
        ...state,
        paymentdata: action.payload // Setze die Paymentdata
      };
    case SET_PAYMENTMOLLIEINSTANCE_SELECTED:
      return {
         ...state,
         paymentmollieinstance: action.payload // Setze die Paymentdata
       };
    case SET_SHIPPINGDATA_SELECTED:
      return {
        ...state,
        shippingdata: action.payload // Setze die Shippingdata
      };
    case SET_PICKUPDATA_SELECTED:
      return {
        ...state,
        pickupdata: action.payload // Setze die Pickupdata
      };
    case SET_SHIPORDELIVERDATA_SELECTED:
      return {
        ...state,
        shipordeliverdata: action.payload // Setze die Pickupdata
      }; 
    case SET_DELIVERORPAYADDRESSDATA_SELECTED:
      return {
        ...state,
        deliverorpayaddressdata: action.payload // Setze die DeliverorPay AddressData
      }; 
      case SET_ADDITIONALFORMINPUT_SELECTED:
        return {
          ...state,
          additionalforminput: action.payload // Setze die Additional Form input
        }; 
    default:
      return state;
  }
};

export default selectedorderdataReducer;